"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getFilterTranslationKey = void 0;
var _models = require("../models");
const getFilterTranslationKey = (filterType)=>{
    if (filterType === _models.DeliveryOptionsFilter.PickUp || filterType === _models.DeliveryMethod.PickupPoint) {
        return 'beautyCenterOriflame';
    }
    if (filterType === _models.DeliveryOptionsFilter.AllAddresses || filterType === _models.DeliveryOptionsFilter.History) {
        return 'all';
    }
    if (filterType === _models.DeliveryOptionsFilter.MyHistoryAddresses) {
        return 'myAddresses';
    }
    if (filterType === _models.DeliveryOptionsFilter.MyHistoryFriends) {
        return 'myFriends';
    }
    const stringValue = String(filterType);
    return stringValue.charAt(0).toLowerCase() + stringValue.slice(1);
};
exports.getFilterTranslationKey = getFilterTranslationKey;
